(ns frontend.view.modals.account-edit.events
  (:require
   [clojure.string :as string]
   [common.util :as cu]
   [frontend.state.current-session :as session]
   [frontend.actions.account :as account-actions]
   [frontend.view.modals.components.processing-modal :as processing-modal]
   [common.email :as email]
   [common.roles :as roles]))

(defn form-ready?
  [state account role]
  (let [{:keys [first-name last-name email role-kw]} @state]
    (and (not (string/blank? first-name))
         (not (string/blank? last-name))
         (not (string/blank? email))
         (email/valid-email-pattern? email))))

(defn unsaved-changes? 
  [state account role]
  (let [{:keys [first-name last-name email role-kw]} @state]
    (or (not= email (:account/email account))
        (not= first-name (:account/first-name account))
        (not= last-name (:account/last-name account))
        (not= role-kw role))))

(defn toggle-set
  [s val]
  (set (if (contains? s val)
         (disj s val)
         (conj s val))))

(defn modify-modules!
  [state kw val]
  (swap! state update kw toggle-set val))

(defn modify-account!
  [state account-id role-id send-email? close! on-submit!]
  (let [{:keys [first-name last-name email role-kw]} @state]
    (processing-modal/start-processing! state)
    (when (roles/is-guest-role? role-kw)
      (account-actions/*->update-guest (cu/remove-empty-vals {:db/id account-id
                                                              :account/first-name first-name
                                                              :account/last-name last-name})
                                       (fn []
                                         (processing-modal/success! state)
                                         (when on-submit!
                                           (on-submit!)))
                                       (fn [err]
                                         (processing-modal/error! state err)
                                         (when on-submit!
                                           (on-submit!)))))))
